import { ContentTypes } from '#app/config/constants'
import { CourseDateList } from './CourseDateList'
import { ImageText } from './imageText'
import { RichContent } from './richContent'
import { Spacer } from './spacer'
import { TastingNote } from './tastingNote'

export const MainContent = ({ main }: any) =>
	main.map((content: any) => {
		switch (content.__typename) {
			case ContentTypes.CONTENTBLOCK: {
				if (!content.content) {
					return null
				}
				return <RichContent key={content.id} content={content.content.raw} />
			}
			case ContentTypes.SPACER:
				return <Spacer size={content.size} id={content.id} />
			case ContentTypes.COURSEDATELIST:
				return <CourseDateList />
			case ContentTypes.IMAGETEXT:
				return (
					<ImageText
						key={content.id}
						image={content.image}
						title={content.title}
						textContent={content.textContent}
						imageLeftRight={content.imageLeftRight}
					/>
				)
			case ContentTypes.TASTINGNOTE:
				return (
					<TastingNote
						title={content.tastingNoteTitle}
						generalInfo={content.generalInfo}
						image={content.imageText.image}
						textContent={content.imageText.textContent}
						imageLeftRight={content.imageText.imageLeftRight}
					/>
				)
			default:
				return <p>No matching component found</p>
		}
	})
